"use client";

/**
 * Fires one tracking event the first time its spot scrolls into view
 * (listing page sections, 2026-10-13: "we need to be able to track this").
 * Drop it inside a section; it renders an empty marker, never layout.
 */
import { useEffect, useRef } from "react";
import { trackEvent } from "@/lib/tracking";

export default function TrackInView({ name, props }: { name: string; props: Record<string, unknown> }) {
  const ref = useRef<HTMLSpanElement | null>(null);
  const key = JSON.stringify(props);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver((es) => {
      if (es.some((e) => e.isIntersecting)) {
        trackEvent(name, props);
        io.disconnect();
      }
    });
    io.observe(el);
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, key]);
  return <span ref={ref} aria-hidden className="block h-px w-px" />;
}
